<div class="detail">
  <div class="part1">
    <img
      src="../../../../../../assets/images/holiday/bell.png"
      alt=""
    />春节假期安排（Feb 10- Feb 24）
  </div>

  <div class="part2">
    <div class="item">
      <span class="dot"></span>
      <span class="txt3">
        <span class="txt4">关于时长：</span>
        <span class="txt5">
          您的账号权益已受到“时长保护”，到期时间已从此刻起
          <p>暂停计算</p>
        </span>
      </span>
    </div>
    <div class="item">
      <span class="dot"></span>
      <span class="txt3">
        <span class="txt4">关于核实：</span>
        <span class="txt5">
          关于核实：请确保您已上传故障截图，待
          <p style="color: #009688">2月25日</p>
          恢复正常办公后，专员将通过
          <p>相关报错截图，系统日志进行双重核实。</p>
        </span>
      </span>
    </div>
    <div class="item">
      <span class="dot"></span>
      <span class="txt3">
        <span class="txt4">关于补偿：</span>
        <span class="txt5">
          关于补偿：经核实属实，我们将为您补齐自动故障发生后的
          <p>受影响的使用时长。</p>
        </span>
      </span>
    </div>
    <div class="item">
      <span class="txt3">
        <span class="txt4">感谢您的耐心与对我们服务的支持！</span>
      </span>
    </div>
  </div>
</div>
